<template>
  <v-navigation-drawer id="app-drawer" app="app" v-model="$store.state.layout.drawer">
    <v-layout class="logo-box" align-center justify-center row fill-height>
      <router-link class="logo-class" to="/">
        <img src="../../../assets/logo-light-icon.png" width="40" />
        <img class="mb-2" src="../../../assets/logo-light-text.png" />
      </router-link>
    </v-layout>
    <v-list class="sidebar-nav" dense="dense">
      <template v-for="item in items">
        <v-list-group class="mb-2" v-if="item.items" :group="item.group" :prepend-icon="item.icon"
          no-action="no-action">
          <v-list-tile slot="activator" ripple="ripple">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <template v-for="(subItem, i) in item.items">
            <v-list-group class="mb-2" v-if="subItem.items" :group="subItem.group" sub-group="sub-group">
              <v-list-tile slot="activator" ripple="ripple">
                <v-list-tile-content>
                  <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-chip class="white--text pa-0 v-chip--x-small" v-if="subItem.badge" :color="subItem.color || 'primary'"
                disabled="disabled" slot="appendIcon">{{ subItem.badge }}</v-chip>
            </v-list-group>
            <v-list-tile v-else :key="i" :to="!subItem.href ? { path: subItem.path } : null" :href="subItem.href"
              :target="subItem.target" rel="noopener" :disabled="subItem.disabled" ripple="ripple">
              <v-list-tile-content>
                <v-list-tile-title>
                  <span>{{ subItem.title }}</span>
                </v-list-tile-title>
              </v-list-tile-content>
              <v-chip class="white--text pa-0 v-chip--x-small" v-if="subItem.badge" :color="subItem.color || 'primary'"
                disabled="disabled">{{ subItem.badge }}</v-chip>
              <v-list-tile-action v-if="subItem.action">
                <v-icon :class="[subItem.actionClass || 'success--text']">{{
                  subItem.action
                }}</v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list-group>
        <v-subheader class="grey--text" v-else-if="item.header">
          <span>{{ item.header }}</span>
          <v-spacer> </v-spacer>
          <span class="ml-1 font-weight-regular font-italic">{{
            version
          }}</span>
        </v-subheader>
        <v-divider v-else-if="item.divider"> </v-divider>
        <v-list-tile v-else :to="!item.href ? { path: item.path } : null" :href="item.href" ripple="ripple"
          :disabled="item.disabled" :target="item.target" rel="noopener">
          <v-list-tile-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
          <v-chip class="white--text pa-0 v-chip--x-small" v-if="item.badge" :color="item.color || 'primary'"
            disabled="disabled">{{ item.badge }}
          </v-chip>
          <v-list-tile-action v-if="item.subAction">
            <v-icon class="success--text">{{ item.subAction }}</v-icon>
          </v-list-tile-action>
          <v-chip class="caption blue lighten-2 white--text mx-0" v-else-if="item.chip" label="label" small="small">{{
            item.chip
          }}
          </v-chip>
        </v-list-tile>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex';
import dashbaordService from '../../Home/service';
import inventoryService from '../../Inventory/service';

import navService from '../service';
import sound from '../../../assets/audio/u_have_a_task.mp3';

const audio = new Audio(sound);

export default {
  data() {
    return {
      version: '2.2.1',
      items: [],
      mini: false,
      right: null,
      leadsBadge: 0,
      ticketsBadge: 0,
      taskBadge: 0,
      inventoryBadge: 0,
      locationBadge: 0,
    };
  },
  computed: {
    ...mapGetters('integration', ['modules']),
    ...mapGetters('global', ['currentUser', 'checkRightStatus']),
  },
  async mounted() {
    await this.getInstallationCount();
    await this.getMissingSerialList();
    await this.getListOfUserDueLeads(this.currentUser.userID);
    await this.getTaskCount(this.currentUser.userID);
    await this.getListOfUserDueTickets(this.currentUser.userID);
    await this.loadNav();
    console.log('currentUser', this.currentUser);
  },
  watch: {
    leadsBadge() {
      this.loadNav();
    },
    ticketsBadge() {
      this.loadNav();
    },
    taskBadge() {
      this.loadNav();
    },
    inventoryBadge() {
      this.loadNav();
    },
    locationBadge() {
      this.loadNav();
    },
  },
  sockets: {
    playTaskSound() {
      audio.play();
    },
    checkTasks() {
      this.getTaskCount(this.currentUser.userID);
    },
    updateInventory() {
      this.getMissingSerialList();
    },
  },
  methods: {
    getMissingSerialList() {
      return inventoryService.getMissingSerialList().then((result) => {
        let total = 0;
        result.data.map((row) => {
          total += row.ProductCount;
        });
        this.inventoryBadge = total;
        return;
      });
    },
    getTaskCount(id) {
      return navService.totalTaskCount(id).then((response) => {
        this.taskBadge = response.data;
        return response.data;
      });
    },
    getListOfUserDueLeads(id) {
      return navService.passdueLeads(id).then((response) => {
        console.log('response.data', response.data);
        this.leadsBadge = response.data;
        return response.data;
      });
    },
    getListOfUserDueTickets(id) {
      return navService.passdueTickets(id).then((response) => {
        console.log('response.data', response.data);
        this.ticketsBadge = response.data;
        return;
      });
    },
    getInstallationCount() {
      return dashbaordService.installationCount().then((result) => {
        this.locationBadge = result.data;
        return result.data;
      });
    },
    loadNav() {
      this.items = [];
      this.items.push({ header: 'Menu' });
      this.items.push({
        title: this.$t('sideBar.home'),
        icon: 'mdi-home',
        name: 'home',
        path: '/home',
      });
      this.items.push({ divider: true });
      if (this.checkRightStatus(2)) {
        this.items.push({
          title: this.$t('sideBar.organization'),
          icon: 'business',
          name: 'organization',
          path: '/organization',
        });
      }
      if (this.checkRightStatus(1)) {
        this.items.push({
          title: this.$t('sideBar.location'),
          icon: 'mdi-store',
          name: 'location',
          path: '/location',
          items: [
            {
              name: 'storeList',
              title: this.$t('sideBar.location'),
              path: '/location',
              badge: this.locationBadge,
            },
            {
              name: 'reconcile',
              title: this.$t('sideBar.reconcile'),
              path: '/reconcile',
            },
          ],
        });
      }
      this.items.push({ divider: true });
      if (this.checkRightStatus(33)) {
        this.items.push({
          title: this.$t('sideBar.leads'),
          icon: 'filter_list',
          name: 'leads',
          path: '/leads',
          badge: this.leadsBadge,
        });
      }
      if (this.checkRightStatus(42)) {
        this.items.push({
          title: this.$t('sideBar.tickets'),
          icon: 'local_offer',
          name: 'ticket',
          path: '/tickets',
          badge: this.ticketsBadge,
        });
      }
      if (this.checkRightStatus(43)) {
        this.items.push({
          title: this.$t('sideBar.tasks'),
          icon: 'description',
          name: 'task',
          path: '/task',
          badge: this.taskBadge,
        });
      }
      if (this.checkRightStatus(33)) {
        this.items.push({
          title: this.$t('sideBar.inventory'),
          icon: 'mdi-dropbox',
          name: 'inventory',
          path: '/inventory',
          badge: this.inventoryBadge,
        });
      }
      if (this.checkRightStatus(62)) {
        this.items.push({
          title: this.$t('sideBar.list'),
          icon: 'insert_comment',
          name: 'activity',
          path: '/activity',
          items: [
            {
              name: 'numberSearch',
              title: this.$t('sideBar.numberSearch'),
              path: '/numberSearch',
            },
            {
              name: 'wallet',
              title: this.$t('sideBar.wallet'),
              path: '/wallet',
            },
            {
              name: 'promotion',
              title: this.$t('sideBar.promotion'),
              path: '/promotion',
            },
            {
              name: 'Activity',
              title: this.$t('sideBar.activity'),
              path: '/activity/activityList',
            },
            {
              name: 'TicketFeedback',
              title: this.$t('sideBar.ticketFeedback'),
              path: '/activity/ticketfeedbacklist',
            },
            {
              name: 'Comment',
              title: this.$t('sideBar.comment'),
              path: '/activity/commentList',
            },
            {
              name: 'Log',
              title: this.$t('sideBar.logs'),
              path: '/activity/loglist',
            },
          ],
        });
      }
      if (this.checkRightStatus(3)) {
        this.items.push({
          title: this.$t('sideBar.invoice'),
          icon: 'description',
          name: 'invoice',
          path: '/invoice',
          items: [
          {
              name: 'openInvoice',
              title: this.$t('sideBar.list'),
              path: '/invoice/list',
            },
            {
              name: 'openInvoice',
              title: this.$t('sideBar.openInvoice'),
              path: '/invoice/openInvoice',
            },
            {
              name: 'passedDueInvoice',
              title: this.$t('sideBar.passedDueInvoice'),
              path: '/invoice/passedDue',
            },
            {
              name: 'manualCharge',
              title: this.$t('sideBar.manualCharge'),
              path: '/invoice/manualCharge',
            },
            {
              name: 'readyToBeMade',
              title: this.$t('sideBar.readyToBeMade'),
              path: '/invoice/readytobemade',
            },
          ],
        });
      }
      if (this.currentUser.accountTypeID <= 2) {
        this.items.push({
          title: this.$t('sideBar.adminTools'),
          group: '',
          icon: 'computer ',
          items: [
            { name: 'User', title: this.$t('sideBar.user'), path: '/user' },
            { name: 'Language', title: 'Language', path: '/language' },
            {
              name: 'adsImage',
              title: this.$t('sideBar.adsImages'),
              path: '/ads',
            },
            {
              name: 'Msj Image',
              title: 'Masjid Image',
              path: '/mads',
            },
          ],
        });
      }
      if (this.checkRightStatus(61)) {
        this.items.push({
          title: 'Bonventa',
          group: '',
          icon: 'money',
          items: [
            { name: 'Location', title: 'Location', path: '/bonventa/location' },
          ],
        });
      }


      this.items.push({
        title: 'Marketing',
        icon: 'filter_list',
        name: 'marketing',
        path: '/marketing',
        items: [
          {
            name: 'group',
            title: 'Group',
            path: '/marketing/group',
          },
          {
            name: 'messages',
            title: 'Messages',
            path: '/marketing/messages',
          },
        ],
      });

      this.items.push({
        title: 'SMS Reports',
        icon: 'mdi-chart-bar',
        name: 'sms-reports',
        path: '/sms-reports',
        items: [
          {
            name: 'walletBalances',
            title: 'Wallet Balances',
            path: '/sms-reports/wallet-balances',
          },
          {
            name: 'usageByMonth',
            title: 'Usage by Month',
            path: '/sms-reports/usage-by-month',
          },
          {
            name: 'purchasedVsUsed',
            title: 'Purchased vs Used',
            path: '/sms-reports/purchased-vs-used',
          },
          {
            name: 'refundHistory',
            title: 'Refund History',
            path: '/sms-reports/refund-history',
          },
        ],
      });

      // this.items.push({
      //   title: this.$t('sideBar.employees'),
      //   icon: 'mdi-account-group',
      //   name: 'employee',
      //   path: '/employee',
      // })

      // this.items.push({
      //   title: this.$t('sideBar.reports'),
      //   icon: 'mdi-file-chart',
      //   name: 'reports',
      //   path: '/reports',
      // })

      // this.items.push({ divider: true })
      // this.items.push({
      //   title: this.$t('sideBar.integrations'),
      //   icon: 'mdi-apps',
      //   name: 'integrations',
      //   path: '/integrations',
      // })
      // this.items.push({ divider: true })

      // this.items.push({
      //   title: this.$t('sideBar.settings'),
      //   icon: 'mdi-settings',
      //   name: 'settings',
      //   path: '/settings',
      // })
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/variable.scss";

.sidebar-nav {
  padding: 8px 35px 8px 15px;
  display: block;
  font-size: 15px;
  border-radius: 4px;
  white-space: nowrap;
  color: $sidebar-text;
}

.logo-box {
  height: 58px;
  background-color: #3a3a3a;
}

.v-chip--x-small {
  font-size: 10px;
  height: 16px;
}

.v-chip--x-small .v-chip__content {
  line-height: 1;
  padding: 8px;
}
</style>
